import moment from 'moment'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { sendStaffAppMetaData } from '../../eventTriggers'

export function PastOccupancies() {
  const { occupancies } = useSelector(state=>state)
  const tabDefaultMetaData = useSelector(state=>state.config.tab_default_meta_data.find(tab=> tab.detail == 'past_occupancies'))
  const dispatch = useDispatch()

  function handleClick(occupancy){
    dispatch({
      type: "EDIT_OCCUPANCY",
      payload: occupancy,
    });

    sendStaffAppMetaData(tabDefaultMetaData.modal)
  }
  
  const filteredPastOccupancies = occupancies.filter(
    (occupancy) => occupancy.moved_out_at !== null && moment(occupancy.moved_out_at).isSameOrBefore(moment())
  );

  return (
    <div>
      {
        filteredPastOccupancies.map(occupancy=>(
          <div key={occupancy.id} onClick={()=>handleClick(occupancy)} className="p-4 border-bottom clickable">
            <b>{!!occupancy.group ? occupancy.group.name : 'No Facility'}</b>
            <div>
              { occupancy.moved_in_at ? moment(occupancy.moved_in_at).format("MM/DD/YYYY") : 'n/a' } -&nbsp;
              { occupancy.moved_out_at ? moment(occupancy.moved_out_at).format("MM/DD/YYYY") : 'Current' }
            </div>
          </div>
        ))
      }
    </div>
  )
}
